/** Keep the top edge anchored when native views scale around their center. */
export function cardLayerPose(height: number, progress: number) {
  'worklet';
  const scale = 0.96 + 0.04 * progress;
  return {
    scale,
    translateY: -16 * (1 - progress) - (height * (1 - scale)) / 2,
  };
}
